// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__-loca-__eeZpu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 118
// module chunks = 0